exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".trustpilot-widget iframe[data-v-fa9f92e4]{align-self:center;display:flex}", ""]);

